<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        btitle="Mapping Config"
        style="height: 410px"
      >
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="isShowAddTable = true"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllMap"
                />
                <label for="idSelectAllMap"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in mapTable"
              :key="row.profileid"
              :class="{ 'true:': true }"
              @click="changeSelect(row)"
            >
              <td width="40px">
                <div @click.stop="" v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectMap' + index"
                  />
                  <label :for="'idRowSelectMap' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.mapId }}</div>
              </td>
              <td>
                <div>{{ row.mapVlan }}</div>
              </td>
              <td>
                <div>{{ row.mapPort }}</div>
              </td>
              <td>
                <div>{{ row.mapPri }}</div>
              </td>
              <td>
                <div>{{ row.mapGemport }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Map Edit'"
            @close="isShowAddTable = false"
            style="min-height: 410px"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="mapId">{{
                  title.mapId
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                  <input
                    type="text"
                    class="form-control"
                    id="mapId"
                    :disabled="isEditClik"
                    v-model="mapForm.mapId"
                    autocomplete="off"
                    placeholder="INTEGER<0-47>"
                  />
                  <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="mapVlan">{{
                  title.mapVlan
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                  <input
                    type="text"
                    class="form-control"
                    id="mapVlan"
                    :disabled ="mapMode == 1 || mapMode == 3 || mapMode == 5 "
                    v-model="mapForm.mapVlan"
                    placeholder="INTEGER<1-4094>"
                  />
                  <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="mapPri">{{
                  title.mapPri
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="mapPri"
                    :disabled ="mapMode == 0 || mapMode == 3 || mapMode == 4 "
                    v-model="mapForm.mapPri">
                    <option value="">
                        None
                      </option>
                      <option value="0">0</option>
                      <option v-for=" pri in 7" :key="pri" :value="pri">{{pri}}</option>
                    </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">Port Type</label>
                <div class="col-sm-7">
                    <label>
                    <input
                      type="radio"
                      class="form-control"
                      :disabled ="mapMode == 0 || mapMode == 1 || mapMode == 2 "
                      value="1"
                      @click="chooseport('1')"
                      id="mapeth"
                      v-model="mapForm.mapType"
                    />
                    <label for="mapeth">Eth</label>
                  </label>
                  <label style="margin-left: 15px">
                    <input
                      type="radio"
                      class="form-control"
                      :disabled ="mapMode == 0 || mapMode == 1 || mapMode == 2 "
                      value="3"
                      id="mapiphost"
                      @click="chooseport('3')"
                      v-model="mapForm.mapType"
                    />
                    <label for="mapiphost">Iphost</label>
                  </label>
                  <label style="margin-left: 15px">
                    <input
                      type="radio"
                      class="form-control"
                      :disabled ="mapMode == 0 || mapMode == 1 || mapMode == 2 "
                      value="2"
                      @click="chooseport('2')"
                      id="mapveip"
                      v-model="mapForm.mapType"
                    />
                    <label for="mapveip">Veip</label>
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="mapPort">{{
                  title.mapPort
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                  <input
                    :disabled="mapForm.mapType != '1'"
                    type="text"
                    class="form-control"
                    id="mapPort"
                    v-model="mapForm.mapPort"
                    placeholder="INTEGER<1-24>"
                  />
                  <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="mapGemport">{{
                  title.mapGemport
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="mapGemport"
                    v-model="mapForm.mapGemport"
                  >
                    <option value="" disabled selected style="display: none">
                      please choose..
                    </option>
                    <option
                      v-for="(gem, index) in gemTable"
                      :key="index"
                      :value="gem.gemPort"
                    >
                      {{ gem.gemPort }}
                    </option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"

export default {
  name: "profileLineMap",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  props: ["profileId", "mapMode"],

  data() {
    return {
      title: {
        mapId: "Mapping Id",
        mapVlan: "Mapping VLAN",
        mapPort: "Mapping Port",
        mapPri: "Mapping Priority",
        mapGemport: "Mapping Gemport",
      },
      isShowAddTable: false,
      isEditClik: false,
      iBox: {},
      isSelectAll: false,
      select: [],

      mapForm: {
        mapId: "",
        mapVlan: "",
        mapPort: "",
        mapPri: "",
        mapGemport: "",
        mapType: 0,
      },

      mapTable: [],
      gemTable: [],
    }
  },

   watch:{
    'mapForm.mapType':function(){
        this.mapForm.mapPort = ""
    }
  },

  created() {
    this.loadMappingInfo()
    this.loadGemportInfo()
  },

  methods: {
    loadMappingInfo() {
      get("profilemapping?profileId=" + this.profileId)
        .then((res) => {
          this.mapTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadGemportInfo() {
      get("profilegemport?profileId=" + this.profileId)
        .then((res) => {
          this.gemTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        mapId: "",
        mapVlan: "",
        mapPort: "",
        mapPri: "",
        mapGemport: "",
        mapType: 0,
      }

      this.mapForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.mapId) - Number(b.mapId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.profileId),
        mapId: Number(this.mapForm.mapId),
        mapVlan: Number(this.mapForm.mapVlan),
        mapPort: Number(this.mapForm.mapPort),
        mapPri: Number(this.mapForm.mapPri),
        mapGemport: Number(this.mapForm.mapGemport),
        mapType: Number(this.mapForm.mapType),
        operate: 1,
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (this.mapForm.mapVlan == "") newProfile.mapVlan = -1
      if (this.mapForm.mapType != 1) {
        newProfile.mapPort = -1
      }
      if (this.mapForm.mapPri == "") newProfile.mapPri = -1

      if (!this.isEditClik) {
        for (let i = 0; i < this.mapTable.length; i++) {
          if (this.mapTable[i].mapId == newProfile.mapId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this map id has been existed,please choose a new one"
            )
            return
          }
        }
      }
      post("profilemapping", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadMappingInfo()
            /*if (newProfile.mapVlan == -1) newProfile.mapVlan = ""
            if (newProfile.mapPort == -1) newProfile.mapPort = ""
            if (newProfile.mapPri == -1) newProfile.mapPri = ""

            if (newProfile.mapType == "3") newProfile.mapPort = "iphost"
            if (newProfile.mapType == "0") newProfile.mapPort = ""
            if (this.isEditClik) 
            {
              let index = this.select[0]
              this.mapTable[index] = newProfile
            }else {
              this.mapTable.push(newProfile)
              this.mapTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.mapTable.length; i++) {
        if (this.mapTable[i].selected) {
          this.mapForm.mapId = this.mapTable[i].mapId
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        mapId: 1,
        operate: 2,
      }

      for (i = 0; i < this.mapTable.length; i++) {
        if (this.mapTable[i].selected) {
          newProfile.profileId = Number(this.profileId)
          newProfile.mapId = Number(this.mapTable[i].mapId)
          del.push(post("profilemapping", newProfile))
          id.push(this.mapTable[i].mapId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.mapTable.length; i++) {
                if (this.mapTable[i].mapId == id[index]) {
                  this.mapTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.mapTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.mapTable[i], "selected", true)
        } else {
          this.$set(this.mapTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    chooseport(value){
      if(value == this.mapForm.mapType)
      {
        this.mapForm.mapType=""
      }
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.mapForm.mapId != "")
        {
            let mapId = Number(this.mapForm.mapId)
            if(!isNaN(mapId))
            {
                if(mapId < 0 || mapId > 47)
                return "map id must be in range 0-47"
            }
            else
              return "map id must be in range 0-47"
        }
      }

      if(value == 2 || value == 0)
      {
        if(this.mapForm.mapVlan != "")
        {
            let oldVlan = Number(this.mapForm.mapVlan)
            if(!isNaN(oldVlan))
            {
                if(oldVlan < 1 || oldVlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }

      if(value == 3 || value == 0)
      {
        if(this.mapForm.mapPort != "")
        {
            let mapPort = Number(this.mapForm.mapPort)
            if(!isNaN(mapPort))
            {
                if(mapPort < 1 || mapPort > 24)
                return "onu port id must be in range 1-24"
            }
            else
              return "onu port id must be in range 1-24"
        }
      }
      return null
    }
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>
